import { render, staticRenderFns } from "./SearchLogsHome.vue?vue&type=template&id=6b990e4d&"
import script from "./SearchLogsHome.vue?vue&type=script&lang=js&"
export * from "./SearchLogsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports